'use client';

import { PopoverClose } from '@radix-ui/react-popover';
import type { Route } from 'next';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';
import { cn } from '@/utils/ui-utils';

interface AccountContentProps {
  closeOnClick?: boolean;
}
export type AccountLink = {
  label: string;
  href: string;
  useNextLink?: boolean;
};

export const accountLinks: AccountLink[] = [
  {
    label: 'Frågor och svar',
    href: '/faq',
    useNextLink: true,
  },
  {
    label: 'Mitt konto',
    href: '/auth/account',
  },
  {
    label: 'Logga ut',
    href: '/auth/logout',
  },
];
const AccountContent = ({ closeOnClick }: AccountContentProps) => {
  const pathname = usePathname();
  return (
    <>
      {accountLinks.map(({ label, href, useNextLink }) => {
        const isActive = pathname.includes(href);

        const classes = cn(
          'focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 relative flex min-h-10 items-center rounded-sm px-2 py-1.5 text-sm font-display transition-colors focus:bg-accent hover:bg-accent focus:text-accent-foreground',
          isActive && 'text-highlight',
        );

        const navigationItem = useNextLink ? (
          <Link
            key={label}
            href={href as Route}
            className={classes}
          >
            {label}
          </Link>
        ) : (
          <a
            key={label}
            href={href}
            className={classes}
          >
            {label}
          </a>
        );

        return closeOnClick ? (
          <PopoverClose
            asChild
            key={href}
          >
            {navigationItem}
          </PopoverClose>
        ) : (
          <React.Fragment key={href}>{navigationItem}</React.Fragment>
        );
      })}
    </>
  );
};

export default AccountContent;
